import React from "react"
import tw, { styled } from "twin.macro"

import QuotesLogosRow from "images/logos/quotes-row.png"
import QuotesSingleLogo from "images/logos/quotes-single.png"
import OpeningQuotes from "images/icons/opening-quotes.svg"

const Styles = styled.div`
  ${tw`flex flex-col items-center mx-auto px-4 m:px-0 mt-8`}

  .speech-balloon {
    ${tw`flex flex-col items-center mx-auto w-full m:w-2/3 l:w-3/5 text-center p-12 l:p-8
         text-yellow italic text-base l:text-xl leading-normal l:leading-normal`}

    background: linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.1) 100%);
    border-radius: 10px;

    img {
      ${tw`mb-6 m:mb-8`}

      width: 28px;

      @media (min-width: 640px) {
        width: 40px;
      }

      @media (min-width: 1024px) {
        width: 42px;
      }
    }
  }

  .balloon-pointer {
    ${tw`mx-auto w-full m:w-2/3 l:w-1/2 mb-4`}

    background-color: rgba(255,255,255,0.1);
    clip-path: polygon(calc(50% - 20px) 0, 50% 100%, calc(50% + 20px) 0);
    height: 30px;
  }

  img {
    ${tw`w-2/3 m:w-full mt-2 m:mt-0`}
  }
`

const Quotes = ({ quote }) => (
  <Styles>
    <div className="speech-balloon">
      <img src={OpeningQuotes} />
      {quote}”
    </div>
    <div className="balloon-pointer"></div>
    <img className="hidden m:block" src={QuotesLogosRow} />
    <img className="m:hidden" src={QuotesSingleLogo} />
  </Styles>
)

export default Quotes
